define([
    './defined',
    './defaultValue',
    './object2Json'
], function (
    defined,
    defaultValue,
    object2Json
) {
    'use strict'

    /**
     * 将对象数组序列化为json字符串。
     *
     * @private
     *
     * @exports array2Json
     */
    const array2Json = (type, arr) => {
        let result = object2Json.stringify(type, arr)
        return result
    };
    return array2Json
});
